// API client for the DogCenter Lappland backend
import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: false,
});

// Bearer token interceptor — pulls from localStorage on each request
api.interceptors.request.use((config) => {
  const token = window.localStorage.getItem("dcl_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Public form submissions
export async function submitNewsletter(email, language) {
  const { data } = await api.post("/api/newsletter", { email, language });
  return data;
}

export async function submitContact({ name, email, message, language }) {
  const { data } = await api.post("/api/contact", { name, email, message, language });
  return data;
}

// Admin
export async function adminLogin(email, password) {
  const { data } = await api.post("/api/auth/login", { email, password });
  return data;
}

export async function adminMe() {
  const { data } = await api.get("/api/auth/me");
  return data;
}

export async function adminStats() {
  const { data } = await api.get("/api/admin/stats");
  return data;
}

export async function adminListNewsletter(status = "all") {
  const { data } = await api.get("/api/admin/newsletter", { params: { status } });
  return data;
}

export async function adminListContact() {
  const { data } = await api.get("/api/admin/contact");
  return data;
}

export async function adminDeleteNewsletter(id) {
  const { data } = await api.delete(`/api/admin/newsletter/${id}`);
  return data;
}

export async function adminDeleteContact(id) {
  const { data } = await api.delete(`/api/admin/contact/${id}`);
  return data;
}

export function adminExportUrl(kind) {
  const token = window.localStorage.getItem("dcl_admin_token");
  return `${API_BASE}/api/admin/${kind}/export.csv?token=${encodeURIComponent(token || "")}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
